import capitalize from 'utils/capitalize';

export const TRANSACTION_PURPOSES = {
  AGENT_CASH: { value: 'agent_cash', title: 'Agent Cash' },
  AGENT_COMMISSION: {
    value: 'agent_commission',
    title: 'Agent Commission',
  },
  ALL_FINE_WRITE_OFF: {
    value: 'all_fine_write_off',
    title: 'All Fines Write-off',
  },
  ATTENDANCE_DELAY_FINES_WRITE_OFF: {
    value: 'attendance_delay_fines_write_off',
    title: 'Delay Fine Write-off',
  },
  ATTENDANCE_DELAY_FINE_WRITE_OFF: {
    value: 'attendance_delay_fine_write_off',
    title: 'Delay Fine Write-off',
  },
  BULK_DEPOSIT: { value: 'bulk_deposit', title: 'Bulk Deposit' },
  BULK_SAVING: { value: 'bulk_saving', title: 'Bulk Saving' },
  BULK_SHARE_OUT: {
    value: 'bulk_share_out',
    title: 'Bulk Share Out',
  },
  BULK_WITHDRAWAL: {
    value: 'bulk_withdrawal',
    title: 'Bulk Withdrawal',
  },
  DROP_OUT: { value: 'drop_out', title: 'Drop Out' },
  FINES: { value: 'fines', title: 'Fines' },
  FINES_ATTENDANCE_DELAY: {
    value: 'fines_attendance_delay',
    title: 'Attendance Delay Fine',
  },
  FINES_MEETING_ABSENCE: {
    value: 'fines_meeting_absence',
    title: 'Meeting Absence Fine',
  },
  FINES_SAVING: { value: 'fines_saving', title: 'Saving Fine' },
  FINES_SOCIAL_FUND: {
    value: 'fines_social_fund',
    title: 'Social Fund Fine',
  },
  FINES_WRITE_OFF: {
    value: 'fines_write_off',
    title: 'Fine Write-off',
  },
  GROUP_CASH: { value: 'group_cash', title: 'Group Cash' },
  GROUP_INTEREST: {
    value: 'group_interest',
    title: 'Group Interest',
  },
  GROUP_MICRO_LOAN: {
    value: 'group_micro_loan',
    title: 'Group Micro Loan',
  },
  GROUP_MICRO_LOAN_SEND_ELIGIBILITY_SMS: {
    value: 'group_micro_loan_send_eligibility_sms',
    title: 'Loan Eligibility SMS',
  },
  GROUP_SUBSCRIPTION_FEES: {
    value: 'group_subscription_fees',
    title: 'Subscription Fees',
  },
  INDIVIDUAL_MICRO_LOAN: {
    value: 'individual_micro_loan',
    title: 'Individual Micro Loan',
  },
  INDIVIDUAL_MICRO_LOAN_GROUP_CUT: {
    value: 'individual_micro_loan_group_cut',
    title: 'Micro Loan Group Cut',
  },
  INDIVIDUAL_MICRO_LOAN_SEND_ELIGIBILITY_SMS: {
    value: 'individual_micro_loan_send_eligibility_sms',
    title: 'Loan Eligibility SMS',
  },
  INDIVIDUAL_WALLET_TOP_UP: {
    value: 'individual_wallet_top_up',
    title: 'Wallet Top Up',
  },
  INDIVIDUAL_WALLET_TRANSFER: {
    value: 'individual_wallet_transfer',
    title: 'Wallet Transfer',
  },
  INDIVIDUAL_WALLET_WITHDRAW: {
    value: 'individual_wallet_withdraw',
    title: 'Wallet Withdrawal',
  },
  LOAD_WALLET: { value: 'load_wallet', title: 'Load Wallet' },
  LOAN: { value: 'loan', title: 'Loan' },
  LOAN_WRITE_OFF: {
    value: 'loan_write_off',
    title: 'Loan Write-off',
  },
  MEETING_ABSENCE_FINES_WRITE_OFF: {
    value: 'meeting_absence_fines_write_off',
    title: 'Absence Fine Write-off',
  },
  MEETING_ABSENCE_FINE_WRITE_OFF: {
    value: 'meeting_absence_fine_write_off',
    title: 'Absence Fine Write-off',
  },
  MICRO_LOAN_INSURANCE: {
    value: 'micro_loan_insurance',
    title: 'Loan Insurance',
  },
  ORG_LOAN: { value: 'org_loan', title: 'Organization Loan' },
  ORG_WALLET_TOPUP: {
    value: 'org_wallet_topup',
    title: 'Wallet Top Up',
  },
  ORG_WALLET_WITHDRAWAL: {
    value: 'org_wallet_withdrawal',
    title: 'Wallet Withdrawal',
  },
  PAY_4G: { value: 'pay_4g', title: '4G Payment' },
  PAY_AIRTIME: { value: 'pay_airtime', title: 'Airtime Payment' },
  PAY_ELECTRICITY: {
    value: 'pay_electricity',
    title: 'Electricity Payment',
  },
  PAY_TV: { value: 'pay_tv', title: 'TV Payment' },
  PAY_WATER: { value: 'pay_water', title: 'Water Payment' },
  PILOTED_GROUP_AMOUNT: {
    value: 'piloted_group_amount',
    title: 'Piloted Group Amount',
  },
  PREVIOUS_SHARES: {
    value: 'previous_shares',
    title: 'Previous Shares',
  },
  REMOVE_MEMBER: { value: 'remove_member', title: 'Remove Member' },
  REVERSAL: { value: 'reversal', title: 'Reversal' },
  SAVING: { value: 'saving', title: 'Saving' },
  SAVING_FINES_WRITE_OFF: {
    value: 'saving_fines_write_off',
    title: 'Saving Fine Write-off',
  },
  SAVING_FINE_WRITE_OFF: {
    value: 'saving_fine_write_off',
    title: 'Saving Fine Write-off',
  },
  SHARE_OUT: { value: 'share_out', title: 'Share Out' },
  SOCIAL_FUND: { value: 'social_fund', title: 'Social Fund' },
  SOCIAL_FUND_FINES_WRITE_OFF: {
    value: 'social_fund_fines_write_off',
    title: 'Social Fund Fine Write-off',
  },
  SOCIAL_FUND_FINE_WRITE_OFF: {
    value: 'social_fund_fine_write_off',
    title: 'Social Fund Fine Write-off',
  },
  SUBSCRIPTION_FEES: {
    value: 'subscription_fees',
    title: 'Subscription Fees',
  },
  TRANSACTION_CHARGE: {
    value: 'transaction_charge',
    title: 'Transaction Charge',
  },
  TRANSFER_GROUP_BALANCE: {
    value: 'transfer_group_balance',
    title: 'Transfer Group Balance',
  },
};

export const getTransactionTitle = purpose => {
  const found = Object.values(TRANSACTION_PURPOSES).find(
    tp => tp.value === purpose,
  );
  return (
    found?.title ||
    capitalize(purpose?.replace(/_/g, ' ') || 'Transaction')
  );
};
